module.exports = __webpack_public_path__ + "static/video-eec03e4542cb395ee766a481196aed36.mp4";